import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
   ChangeShowAlternativeDeviceEditor,
   ChangeShowStatusDropdown,
   ChangeShowPrivateDn,
   ChangeShowUsername,
   ChangeShowBackgroundImage,
   ChangeShowAvatar,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/user-status-brick-settings/user-status-brick-settings.actions';
import { UserStatusBrickSettingsStateSelectors } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/user-status-brick-settings/user-status-brick-settings.selectors';
import { map } from 'rxjs/operators';

@Component({
   selector: 'samweb-user-status-brick-settings',
   templateUrl: './user-status-brick-settings.component.html',
   styleUrls: ['./user-status-brick-settings.component.scss'],
})
export class UserStatusBrickSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   brickInstanceId: string;

   public showAlternativeDeviceEditor$: Observable<boolean>;
   public showStatusDropdown$: Observable<boolean>;
   public showUsername$: Observable<boolean>;
   public showPrivateDn$: Observable<boolean>;
   public showAvatar$: Observable<boolean>;
   public showBackgroundImage$: Observable<boolean>;

   constructor(private store: Store) {
      // nothing to do
   }

   ngOnInit() {
      this.showAlternativeDeviceEditor$ = this.store
         .select(UserStatusBrickSettingsStateSelectors.getIsAlternativeDeviceEditorShown)
         .pipe(map((fn) => fn(this.brickInstanceId)));

      this.showStatusDropdown$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsStatusDropdownShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showUsername$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsUsernameShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showPrivateDn$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsPrivateDnShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showAvatar$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsAvatarShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showBackgroundImage$ = this.store
         .select(UserStatusBrickSettingsStateSelectors.getIsBackgroundImageShown)
         .pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowBackgroundImage(value: boolean) {
      this.store.dispatch(new ChangeShowBackgroundImage(this.brickInstanceId, value));
   }

   changeShowUsername(value: boolean) {
      this.store.dispatch(new ChangeShowUsername(this.brickInstanceId, value));
   }

   changeShowPrivateDn(value: boolean) {
      this.store.dispatch(new ChangeShowPrivateDn(this.brickInstanceId, value));
   }

   changeShowAvatar(value: boolean) {
      this.store.dispatch(new ChangeShowAvatar(this.brickInstanceId, value));
   }

   changeShowAlternativeDeviceEditor(value: boolean) {
      this.store.dispatch(new ChangeShowAlternativeDeviceEditor(this.brickInstanceId, value));
   }

   changeShowStatusDropdown(value: boolean) {
      this.store.dispatch(new ChangeShowStatusDropdown(this.brickInstanceId, value));
   }
}
